import { useState, useCallback, useEffect } from "react";
import { message } from "antd";
import type { GetKycQuestionnaireQuery } from "../../graphql";
import sdk from "../../sdk";

export const useKycQuestionnaireDetail = ({ _id }: { _id: string }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<GetKycQuestionnaireQuery | null>(null);

  const getQuestionnaire = useCallback(() => {
    if (!_id) return;
    setLoading(true);
    sdk
      .getKycQuestionnaire({ _id })
      .then((data) => setData(data))
      .catch((err) => {
        message.warn(err.response?.errors[0]?.message, 2);
      })
      .finally(() => setLoading(false));
  }, [_id]);

  useEffect(() => {
    getQuestionnaire();
  }, [getQuestionnaire]);

  return {
    data: data?.getKycQuestionnaire,
    loading,
    getQuestionnaire,
  };
};
